import { hydrate } from 'react-dom';
import { App } from 'blog/app';

const root = document.getElementById('root');
hydrate(App, root);
